import React from "react";
import ClasicAboutCeoMessage from "./ClasicAboutCeoMessage";
import LandscapeCeoMessage from "./LandscapeCeoMessage";
import CenteredPortraitCeoMessage from "./CenteredPortraitCeoMessage";
import { useSelector } from "react-redux";

function CeoMessageWrapper() {
  const sitedata = useSelector((store) => store.global.loginData);
  return (
    <>
      {sitedata?.theme_ceo_message === "centered-portrait" ? (
        <CenteredPortraitCeoMessage />
      ) : sitedata?.theme_ceo_message === "wide-landscape" ? (
        <LandscapeCeoMessage />
      ) : (
        <ClasicAboutCeoMessage />
      )}
    </>
  );
}

export default CeoMessageWrapper;
